/**
 * Retrieves the translation of text.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/packages/packages-i18n/
 */
import { __ } from '@wordpress/i18n';

/**
 * React hook that is used to mark the block wrapper element.
 * It provides all the necessary props like the class name.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/packages/packages-block-editor/#useblockprops
 */
// import { useBlockProps } from '@wordpress/block-editor';
import { useBlockProps,
	AlignmentControl,
	RichText,
	InspectorControls,
	PanelColorSettings,
	MediaUpload,
    InnerBlocks
	} from '@wordpress/block-editor';
import { useMemo , Fragment} from '@wordpress/element';

import ColorPopup from '../Components/ColorPopup';
import shortUuid from 'short-uuid';

import {
	PanelBody ,
	PanelRow,
	TextControl,
	__experimentalNumberControl as NumberControl,
	__experimentalBorderBoxControl as BorderBoxControl,
	__experimentalBoxControl as BoxControl,
	RangeControl,
	ToggleControl,
	ColorPalette,
	SelectControl,
    CheckboxControl,
	Card,
	CardBody,
    CardFooter ,
	CardHeader,
	TabPanel,
	Flex, FlexBlock, FlexItem,
    ColorPicker,
    DateTimePicker 
	} from '@wordpress/components';


    import { Bar, Line } from 'react-chartjs-2';


import { GLOBAL_FONTS } from '../Global/GLOBAL_FONTS';
import { GLOBAL_FONTS_WEIGHTS } from '../Global/Global_Font_Weights';
import { GLOBAL_ICONS } from '../Global/Global_Icons';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAlignCenter, faAlignLeft, faAlignRight, faHeading, faStar, faPlusCircle } from '@fortawesome/free-solid-svg-icons';

import { useSelect } from '@wordpress/data';
import {withSelect} from '@wordpress/data';
import { RawHTML, useState, useEffect } from '@wordpress/element';
import Chart from 'chart.js/auto';
import apiFetch from '@wordpress/api-fetch';

/**
 * Lets webpack process CSS, SASS or SCSS files referenced in JavaScript files.
 * Those files can contain any CSS code that gets applied to the editor.
 *
 * @see https://www.npmjs.com/package/@wordpress/scripts#using-css
 */
import './editor.scss';


/**
 * The edit function describes the structure of your block in the context of the
 * editor. This represents what the editor will render when the block is used.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-edit-save/#edit
 *
 * @return {Element} Element to render.
 */

function edit({ attributes, setAttributes, props }) {

    const { k2_total_courses,
        SelectedK2Course, 
        no_of_students, 
        selectedTimeFrame,
        LDdateKeys, 
        LDdateValues,
        DEldWidth,
        DEldHeight,
        DElsLineColor,
        DELDgraphAlignment,
        LDChartid
    } = attributes;
    
   
    useEffect(() => {
		// if (!k2_total_courses_students) {
		wp.apiFetch({
			path: '/wp/v1/courses/k2learndash'
	    })
        .then((posstType) => {
            setAttributes({
                k2_total_courses: posstType
            });
            setAttributes({ LDChartid: "myChart-" + shortUuid.generate() });
        })
        .catch((error) => {
            console.error('Error fetching k2_total_courses:', error);
        });
		// }
	},[]);

    var UpdateK2TotalCourses = (val) => {
        setAttributes({SelectedK2Course:val})
    }

    var UpdateselectedTimeFrame = (val) => {
        setAttributes({selectedTimeFrame:val})
    }

    console.log("selected time frame",selectedTimeFrame)

    const generateDateLabels = () => {
        const labels = [];
        for (let i = 6; i >= 0; i--) {
          const date = new Date();
          date.setDate(date.getDate() - i);
          labels.push(date.toLocaleDateString('en-US', { day: 'numeric', month: 'numeric', year: 'numeric' }));
        }
        console.log("past 7 days",labels);
        return labels;
    };

    const generateMonthLabels = () => {
        const labels = [];
        const currentDate = new Date();
        
        for (let i = 11; i >= 0; i--) {
            const date = new Date();
            date.setMonth(currentDate.getMonth() - i);
            const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Ensure two digits
            const year = date.getFullYear();
            labels.push(`${month}/${year}`);
        }
        
        console.log("past 12 months", labels);
        return labels;
    };

    const generateLastMonthLabels = () => {
        const labels = [];
        const currentDate = new Date();
        const lastMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, 1);
        const daysInLastMonth = new Date(lastMonth.getFullYear(), lastMonth.getMonth() + 1, 0).getDate();
    
        for (let i = 1; i <= daysInLastMonth; i++) {
            const formattedDay = `${i.toString().padStart(2, '0')}/${(lastMonth.getMonth() + 1).toString().padStart(2, '0')}/${lastMonth.getFullYear()}`;
            labels.push(formattedDay);
        }
    
        console.log("past month days", labels);
        return labels;
    };

    const getMonthName = (monthNumber) => {
        const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
        return monthNames[parseInt(monthNumber, 10) - 1];
    };

    const generateLastThirtyDaysLabels = () => {
        const labels = [];
        const today = new Date(); // Get today's date
        for (let i = 29; i >= 0; i--) {
            const date = new Date(today); // Create a new date object for each day
            date.setDate(date.getDate() - i); // Subtract i days from today
            labels.push(date.toLocaleDateString('en-US', { month: 'numeric', day: 'numeric', year: 'numeric' }));
        }
        console.log("lables thrity days", labels);
        return labels;
    };

    const generateLastThreeMonthsLabels = () => {
        const labels = [];
        const currentDate = new Date();
        
        for (let i = 2; i >= 0; i--) {
            const date = new Date();
            date.setMonth(currentDate.getMonth() - i);
            const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Ensure two digits
            const year = date.getFullYear();
            labels.push(`${month}/${year}`);
        }
        
        console.log("past 3 months", labels);
        return labels;
    };

    
    useEffect(() => {
        if(SelectedK2Course){
            var path = "/wp/v1/k2learndash/student?courseId="+SelectedK2Course;
            console.log(path);
            wp.apiFetch({
                path: path
            })
            
            .then((data) => {
                console.log("DATA", data);
    
                // Initialize dateCounts as an object to store counts for each date
                const dateCounts = {};
                let dateCountsFinal = {};
                let monthCountsFinal = {};
                

                // Generate labels for the past seven days
                if(selectedTimeFrame == 'last_week'){
                    console.log("last wweek")
                    const pastSevenDays = generateDateLabels();

                    // Initialize dateCounts with counts set to 0 for each date
                    pastSevenDays.forEach(date => {
                        dateCounts[date] = new Set(); // Use Set to store unique user IDs for each date
                    });
    
                    console.log("date counts", dateCounts);
    
                    // Process API data and count unique user enrollments for relevant dates
                    data.forEach(student => {
                        const date = student["activity_started"].split()[0];
                        console.log("date in loop", date);
                        if (pastSevenDays.includes(date)) {
                            console.log("date inside the check", date);
                            // Add the user ID to the Set for the corresponding date
                            dateCounts[date].add(student.user_id);
                        }
                    });
    
                    // Convert the Set to array and count the length to get the number of unique users for each date
                    const dateCountsFinal = {};
                    Object.keys(dateCounts).forEach(date => {
                        dateCountsFinal[date] = dateCounts[date].size;
                    });
    
                    console.log("matched data", dateCountsFinal);
                    setAttributes({
                        no_of_students: data,
                        LDdateKeys: Object.keys(dateCountsFinal),
                        LDdateValues: Object.values(dateCountsFinal)
                    });
                    console.log("no of students",no_of_students)
                }
                else if (selectedTimeFrame == 'last_year') {
                    const pastYear = generateMonthLabels();
                    const monthCounts = {};
                    pastYear.forEach(month => {
                        monthCounts[month] = new Set(); // Use Set to store unique user IDs for each month
                    });
                
                    console.log("month counts", monthCounts);
                
                    // Process API data and count unique user enrollments for relevant months
                    data.forEach(student => {
                        const date = student["activity_started"];
                        const [month, day, year] = date.split('/'); // Adjusting to 'MM/DD/YYYY' format
                        const formattedMonth = `${month.padStart(2, '0')}/${year}`;
                        console.log("month in loop", formattedMonth);
                        if (pastYear.includes(formattedMonth)) {
                            console.log("month inside the check", formattedMonth);
                            // Add the user ID to the Set for the corresponding month
                            monthCounts[formattedMonth].add(student.user_id);
                        }
                    });
                
                    // Convert the Set to array and count the length to get the number of unique users for each month
                    const monthCountsFinal = {};
                    Object.keys(monthCounts).forEach(month => {
                        monthCountsFinal[month] = monthCounts[month].size;
                    });
                
                    // Convert month numbers to month names
                    const monthKeysWithNames = Object.keys(monthCountsFinal).map(key => {
                        const [month, year] = key.split('/');
                        return `${getMonthName(month)} ${year}`;
                    });
                
                    console.log("matched count data", monthCountsFinal);
                    setAttributes({
                        no_of_students: data,
                        LDdateKeys: monthKeysWithNames,
                        LDdateValues: Object.values(monthCountsFinal)
                    });
                    console.log("no of students", data);
                }
                else if(selectedTimeFrame == 'last_month'){
                    const pastThirtyDays = generateLastThirtyDaysLabels(); // Assuming you have a function to generate the past 30 days
                    const weekCounts = {};

                    // Initialize week counters
                    let currentWeek = 1;
                    let weekStartDate = new Date(pastThirtyDays[0]); // Start from the first day of the past 30 days

                    // Iterate over each day of the past 30 days
                    pastThirtyDays.forEach(day => {
                        const currentDate = new Date(day);
                        // Check if a new week has started (every 7 days)
                        if (currentDate.getDay() === 0 && currentDate.getDate() !== weekStartDate.getDate()) {
                            currentWeek++; // Increment week counter
                            weekStartDate = currentDate; // Update the start date of the current week
                        }
                        // Construct week label
                        const weekLabel = `Week ${currentWeek}`;
                        // Add the current day to the corresponding week
                        if (!weekCounts[weekLabel]) {
                            weekCounts[weekLabel] = [];
                        }
                        weekCounts[weekLabel].push(day);
                    });

                    console.log("Weeks", weekCounts);

                    // Match the data with the weeks
                    const weekDataCounts = {};
                    Object.keys(weekCounts).forEach(week => {
                        weekDataCounts[week] = 0; // Initialize count for each week
                        const weekDates = weekCounts[week];
                        weekDates.forEach(weekDay => {
                            // Check if the activity started date falls within the current week
                            console.log("Checking activity start dates for", weekDay);
                            data.forEach(student => {
                                console.log("Comparing with student activity start date", student.activity_started);
                                if (student.activity_started === weekDay) {
                                    console.log("Match found for", weekDay);
                                    weekDataCounts[week]++;
                                }
                            });
                        });
                    });

                    console.log("Week Data Counts", weekDataCounts);

                    // Set the attributes with the data for the past 30 days grouped by weeks
                    setAttributes({
                        no_of_students: data,
                        LDdateKeys: Object.keys(weekDataCounts),
                        LDdateValues: Object.values(weekDataCounts)
                    });
                }
                else if(selectedTimeFrame == 'last_quarter'){
                    const pastYear = generateLastThreeMonthsLabels();
                    const monthCounts = {};
                    pastYear.forEach(month => {
                        monthCounts[month] = new Set(); // Use Set to store unique user IDs for each month
                    });
                
                    console.log("month counts", monthCounts);
                
                    // Process API data and count unique user enrollments for relevant months
                    data.forEach(student => {
                        const date = student["activity_started"];
                        const [month, day, year] = date.split('/'); // Adjusting to 'MM/DD/YYYY' format
                        const formattedMonth = `${month.padStart(2, '0')}/${year}`;
                        console.log("month in loop", formattedMonth);
                        if (pastYear.includes(formattedMonth)) {
                            console.log("month inside the check", formattedMonth);
                            // Add the user ID to the Set for the corresponding month
                            monthCounts[formattedMonth].add(student.user_id);
                        }
                    });
                
                    // Convert the Set to array and count the length to get the number of unique users for each month
                    const monthCountsFinal = {};
                    Object.keys(monthCounts).forEach(month => {
                        monthCountsFinal[month] = monthCounts[month].size;
                    });
                
                    // Convert month numbers to month names
                    const monthKeysWithNames = Object.keys(monthCountsFinal).map(key => {
                        const [month, year] = key.split('/');
                        return `${getMonthName(month)} ${year}`;
                    });
                
                    console.log("matched count data", monthCountsFinal);
                    setAttributes({
                        no_of_students: data,
                        LDdateKeys: monthKeysWithNames,
                        LDdateValues: Object.values(monthCountsFinal)
                    });
                    console.log("no of students", data);
                }
            })
            .catch((error) => {
                console.error('Error fetching no of student:', error);
            });
        }
    }, [SelectedK2Course, selectedTimeFrame, LDdateKeys, LDdateValues]); 

    const [chartRef, setChartRef] = useState(null);

    // useEffect(() => {
    //     return () => {
    //         if (chart) {
    //             chart.destroy(); // Clean up chart when component unmounts
    //         }
    //     };
    // }, [chart]);


    const onChangeDElsLineColor = (newColor) => {
        setAttributes({DElsLineColor:newColor});
    }
    
    // useEffect(() => {
    //     if (chart) {
    //         chart.destroy(); // Destroy existing chart if it exists
    //     }
    //     console.log("LDdateKeys",LDdateKeys)
    //     console.log("LDdateValues: ",LDdateValues);
    //     if (LDdateValues && LDdateValues.length > 0) {
    //         var LDmaxValue = Math.max(...LDdateValues);
    //         console.log(LDmaxValue);
    //     }
    //     const chartData = {
    //         labels: LDdateKeys,
    //         datasets: [
    //             {
    //                 data: LDdateValues,
    //                 borderColor: DElsLineColor,
    //                 borderWidth: 2,
    //                 fill: false,
    //             },
    //         ],
    //     };
    //     const ctx = document.getElementById(LDChartid)?.getContext('2d');
    //     if (ctx) {
    //         chart = new Chart(ctx, {
    //             type: 'bar',
    //             data: chartData,
    //             options: {
    //                 responsive: true,
    //                 maintainAspectRatio: false,
    //                 scales: {
    //                     y: {
    //                         beginAtZero: true,
    //                         suggestedMax: LDmaxValue + 5,
    //                         offset:true,
    //                         ticks:{
    //                             stepSize:1
    //                         }
    //                     },
    //                 },
    //                 plugins: {
    //                     legend: {
    //                         display: false,
    //                     },
    //                     title: {
    //                         display: true,
    //                         text: 'Number of Students',
    //                     },
    //                 },
    //             },
    //         });
    //     }
        
    // }, [LDdateKeys, LDdateValues, DElsLineColor, LDChartid]);


    const chartData = {
        labels: LDdateKeys,
        datasets: [
            {
                label: 'Number of Students',
                data: LDdateValues,
                borderColor: DElsLineColor,
                borderWidth: 2,
                fill: false,
                tension: 0.3, // This property adds a slight curve to the line
            },
        ],
    };

    const chartOptions = {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
            y: {
                beginAtZero: true,
                suggestedMax: Math.max(...LDdateValues) + 2,
                offset:true,
                ticks:{
                    stepSize:1
                }
            },
        },
        plugins: {
            legend: {
                display: false,
            },
            title: {
                display: true,
                text: 'Number of Students',
            },
            tooltip: {
                callbacks: {
                    label: (context) => `${context.dataset.label}: ${context.raw}`,
                },
            },
        },
    };

    const updateChart = () => {
        if (chartRef) {
            chartRef.current.update(); // Update chart using the reference
        }
    };
    
    const onChangeDEldWidth = (val) => {
        setAttributes({DEldWidth:val})
    }

    const onChangeDEldHeight = (val) => {
        setAttributes({DEldHeight:val})
    }

    let CardStyles = {
        width: DEldWidth+"px",
        height:DEldHeight+"px"
    }

    function onChangeAlignmentIconChange(value) {

		if (value.target.tagName === 'SPAN'){
			var ParentDiv = value.target.parentNode
			var MainDiv = ParentDiv.parentNode
			var Spans = MainDiv.getElementsByTagName('div');
			for (var i = 0; i < Spans.length; i++) {
				if (Spans[i].getElementsByTagName('span')[0].className.includes('k2-ib-active')){
					Spans[i].getElementsByTagName('span')[0].className = Spans[i].getElementsByTagName('span')[0].className.replace('k2-ib-active','')
				}
			}
			value.target.className = value.target.className + ' k2-ib-active'

		}

	}
    let onChangeDELDgraphAlignment = (newVal) => {
        setAttributes({DELDgraphAlignment:newVal})
    }
    let graphAlignment = {
        display:'flex',
        justifyContent:DELDgraphAlignment
    }
    return(
        <div {...useBlockProps()} style={graphAlignment}>
            <div className='K2-LD-chart-main-parent-container-edit' style={CardStyles}>
                {/* <canvas id={LDChartid} ></canvas> */}
                <Line ref={setChartRef} data={chartData} options={chartOptions} />
            </div>
           <InspectorControls>
                <PanelBody title={__("Course Filter")}>
                    <Card>
                        <CardBody>
                            {k2_total_courses &&
                                <SelectControl 
                                    label="Select Course"
                                    value={ SelectedK2Course }
                                    onChange={UpdateK2TotalCourses}
                                    options={[
                                        { label: 'Select Course', value: 'select_course' },
                                        { label: 'All', value: '0' },
                                        ...(k2_total_courses &&
                                            k2_total_courses.map((index) => ({
                                            label: index.title,
                                            value: index.id,
                                        })))
                                    ]}

                                />
                            }
                        </CardBody>
                        <CardBody>
                                <SelectControl 
                                    label="Select TIme frame"
                                    value={ selectedTimeFrame }
                                    onChange={UpdateselectedTimeFrame}
                                    options={[
                                        { label: 'Select TimeFrame', value: '0' },
                                        { label: 'Last week', value: 'last_week' }, // Default option
                                        { label: 'Last month', value: 'last_month' },
                                        { label: 'Last quarter', value: 'last_quarter' },
                                        { label: 'Last year', value: 'last_year' },
                                    ]}

                                />
                        </CardBody>
                    </Card>
                </PanelBody>
                <PanelBody title={__("Graph Styles")}>
                    <Card>
                        <CardBody>
                            <ColorPopup 
                                label={"Line Color"}
                                value={{ value: DElsLineColor}}
                                onChange = {onChangeDElsLineColor}
                                PropertyName={"backgroundColor"}
                            />
                        </CardBody>
                        <CardHeader>Spacing</CardHeader>
                        <CardBody>
                            <NumberControl 
                                label='Width'
                                value={DEldWidth}
                                onChange={onChangeDEldWidth}
                            />
                            <NumberControl 
                                label='Height'
                                value={DEldHeight}
                                onChange={onChangeDEldHeight}
                            />
                        </CardBody>
                        <CardHeader>Alignment</CardHeader>
                        <CardBody>
                            <PanelRow>
                                <div style={{paddingBottom: '2%'}}>
                                    <label><strong>Widget Alignment</strong></label>
                                </div>
                                <div id = {'AlignmentIconsParent'} className={'k2-ib-inspector-control-alignment'} onClick={onChangeAlignmentIconChange}>

                                    <div className={'k2-ib-inspector-control-alignment-single'}  onClick={() => onChangeDELDgraphAlignment('flex-start')}>
                                        <span className="fa fa-align-left k2-ib-alignment-icon-style" ></span>
                                    </div>
                                    <div className={'k2-ib-inspector-control-alignment-single'} onClick={() => onChangeDELDgraphAlignment('center')}>
                                        <span className="fa fa-align-center k2-ib-alignment-icon-style k2-ib-active"></span>
                                    </div>
                                    <div className={'k2-ib-inspector-control-alignment-single'} onClick={() => onChangeDELDgraphAlignment('flex-end')}>
                                        <span className="fa fa-align-right k2-ib-alignment-icon-style"></span>
                                    </div>
                                </div>

                            </PanelRow>
                        </CardBody>
                    </Card>
                </PanelBody>
            </InspectorControls>
        </div>
    );

}

export default edit;
